<ng-template #updateReadyMessage let-toast
  >A new version of For The Record is available,
  <a ftrFocusableNoopAnchor (click)="restartApp(toast)">restart the app</a> to get the latest features.</ng-template
>

<ng-template #updateRequiredMessage let-toast
  >This version of the app is out of date. Please install the
  <a [href]="downloadUrl" target="_blank">latest version</a> or contact your administrator to update the
  app.</ng-template
>
